import { useState } from 'react'
import { Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import TokTokDocDialog from '../../Common/Dialog'
import { useAppDispatch } from '../../../store'
import ToktokdocLib from '@saas/lib/toktokdoc-lib/web'
import { FillAddressIcon } from '../../../assets/icons/icons'
import useStyles from './_styles'
import { PlannedExpertiseDeleteDialogProps } from './_props'

const PlannedExpertiseFillAddressDialog = ({
    isOpen,
    plannedExpertiseId,
    onClose,
}: PlannedExpertiseDeleteDialogProps) => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const [isDeletionLoading, setIsDeletionLoading] = useState(false)
    const classes = useStyles()

    const handleDelete = async () => {
        setIsDeletionLoading(true)
        try {
            const transmission = await ToktokdocLib.Transmission.findOne(plannedExpertiseId)

            if (transmission) {
                if (typeof (transmission as any).endByCaregiver === 'function') {
                    await (transmission as any).endByCaregiver()
                } else if (typeof (transmission as any).delete === 'function') {
                    await (transmission as any).delete()
                }
            }

            onClose()
            navigate(`/patient/${plannedExpertiseId}`)
        } catch {
            onClose()
            navigate(`/patient/${plannedExpertiseId}`)
        } finally {
            setIsDeletionLoading(false)
        }
    }

    return (
        <TokTokDocDialog
            isOpen={isOpen}
            handleClose={onClose}
            handleSave={handleDelete}
            handleCancel={onClose}
            saveTitle="Abandonner"
            title="Êtes-vous sûr de vouloir abandonner la téléexpertise en cours pour être redirigé vers la fiche du patient ?"
            loading={isDeletionLoading}
            disableEscape={false}
            buttonsOptions={{
                colors: {
                    save: '#313336',
                    cancel: undefined,
                },
            }}
            dialogProps={{
                fullScreen: false,
                slotProps: {
                    backdrop: {
                        className: classes.PlannedExpertiseFillAddressDialogBackdrop,
                    },
                },
            }}
        >
            <Typography className={classes.PlannedExpertisePopUpDelete}>
                En poursuivant, la téléexpertise sera supprimée
            </Typography>
            <FillAddressIcon />
        </TokTokDocDialog>
    )
}

export default PlannedExpertiseFillAddressDialog
